import ColeDitionedLogo from '../assets/brands/coleditioned/ColeDitioned-Logo-Transparent.png';
import ColeDitionedLogoLarge from '../assets/brands/coleditioned/ColeDitioned-Logo-Transparent-Large.png';
import ColeDitionedWhite from '../assets/brands/coleditioned/ColeDitioned-Logo-full.png';

export const BRANDS = {
  default: {
    name: 'ColeDitioned Coaching',
    slug: 'coleditioned',
    subdomain: 'coleditioned',
    logos: {
      full: ColeDitionedLogo,
      fullLarge: ColeDitionedLogoLarge,
      fullWhite: ColeDitionedWhite,
    },
    colors: {
      'cl-off-white': '#f8f8f6',
      'cl-white': '#ffffff',
      'cl-light': '#d9d9d9',
      'cl-sage': '#4d4d4d',
      'cl-forest': '#121212',
      'cl-blue': '#d4af37', // gold
      'cl-black': '#0b0b0b',
      'gt-red': '#b8860b', // deep gold accent
      'gt-blue': '#888888', // neutral gray accent
    },
    supportEmail: 'support@coleditioned.com',
    legalName: 'ColeDitioned Coaching',
  },
};

export function resolveBrand(hostname) {
  if (!hostname) return BRANDS.default;
  const subdomain = hostname.split('.')[0];
  const match = Object.values(BRANDS).find((brand) => brand.subdomain === subdomain);
  return match || BRANDS.default;
}
